import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { Button, Dropdown, Form, Grid, Label } from 'semantic-ui-react';
import { projectActions } from '../../actions/project.actions';
import { clientActions } from '../../actions/client.actions';
import { teamActions } from '../../actions/team.actions';
import { userActions } from '../../actions/user.actions';
import './styles.css';

class ProjectCreateScreen extends Component {
  constructor(props) {
    super(props);

    this.state = {
      name: '',
      client_id: null,
      teams_id: [],
      status_id: null,
      owner_id: null,
      submitted: false,
    };

    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  componentDidMount() {
    const { dispatch } = this.props;

    dispatch(projectActions.getStatusProjects());
    dispatch(clientActions.getAll());
    dispatch(teamActions.getAll());
    dispatch(userActions.getCompanyUsers());
  }

  handleChange(e, data) {
    if (data) {
      this.setState({ [data.name]: data.value });
    } else {
      const { name, value } = e.target;
      this.setState({ [name]: value });
    }
  }

  handleSubmit(e) {
    e.preventDefault();

    this.setState({ submitted: true });
    const { name, client_id, status_id, teams_id, owner_id } = this.state;
    const { dispatch } = this.props;
    if (name && client_id && status_id) {
      let payload = {
        name,
        client_id,
        status_id,
        owner_id,
      };

      if (teams_id && teams_id.length) {
        payload.teams = teams_id;
      }

      dispatch(projectActions.create(payload, this.props.history));
    }
  }

  render() {
    const { name, client_id, teams_id, status_id, owner_id, submitted } = this.state;
    const { clients, status, teams, users, loading } = this.props;
    let clientOptions,
      statusOptions,
      teamOptions,
      userOptions = [];

    if (clients && clients.data !== undefined) {
      clientOptions = clients.data.map((item) => {
        return { key: item.id, value: item.id, text: item.name };
      });
    }

    if (teams && teams.data !== undefined) {
      teamOptions = teams.data.map((item) => {
        return { key: item.id, value: item.id, text: item.name };
      });
    }

    if (users && users.data !== undefined) {
      userOptions = users.data.map((item) => {
        return { key: item.id, value: item.id, text: item.name };
      });
    }

    if (status !== undefined) {
      statusOptions = status.data.map((item) => {
        return { key: item.id, value: item.id, text: item.name };
      });
    }

    return (
      <Fragment>
        <Grid className="header-page">
          <Grid.Column mobile={16} tablet={16} computer={16}>
            <h1>Novo Projeto</h1>
          </Grid.Column>
        </Grid>
        <Form onSubmit={this.handleSubmit} loading={loading}>
          <Form.Field>
            <label>Nome do Projeto</label>
            <input
              name="name"
              placeholder="Nome do Projeto"
              value={name}
              onChange={this.handleChange}
            />
            {submitted && !name && (
              <Label basic color="red" pointing>
                Nome é requerido
              </Label>
            )}
          </Form.Field>
          <Form.Field>
            <label>Cliente</label>
            <Dropdown
              placeholder="Cliente"
              fluid
              search
              selection
              name="client_id"
              options={clientOptions}
              onChange={(event, data) => this.handleChange(true, data)}
              value={client_id}
            />
            {submitted && !client_id && (
              <Label basic color="red" pointing>
                Cliente é requerido
              </Label>
            )}
          </Form.Field>
          <Form.Field>
            <label>Status</label>
            <Dropdown
              placeholder="Status do Projeto"
              name="status_id"
              value={status_id}
              fluid
              search
              selection
              onChange={(event, data) => this.handleChange(true, data)}
              options={statusOptions}
            />
            {submitted && !status_id && (
              <Label basic color="red" pointing>
                Status é requerido
              </Label>
            )}
          </Form.Field>
          <Form.Field>
            <label>Responsável</label>
            <Dropdown
              placeholder="Responsável do Projeto"
              name="owner_id"
              value={owner_id}
              fluid
              search
              selection
              onChange={(event, data) => this.handleChange(true, data)}
              options={userOptions}
            />
          </Form.Field>
          <Form.Field>
            <label>Times</label>
            <Dropdown
              name="teams_id"
              value={teams_id}
              onChange={(event, data) => this.handleChange(true, data)}
              placeholder="Time"
              fluid
              multiple
              search
              selection
              options={teamOptions}
            />
          </Form.Field>
          <Button primary type="submit">
            Criar
          </Button>
        </Form>
      </Fragment>
    );
  }
}

function mapStateToProps(state) {
  const { projects, clients, teams, users } = state;
  return {
    projects,
    teams,
    clients,
    loading: projects.loading || false,
    status: projects.status,
    users: users.companyUsers,
  };
}

const connectedProjectCreateScreen = connect(mapStateToProps)(ProjectCreateScreen);
export { connectedProjectCreateScreen as ProjectCreateScreen };
